module.exports = __webpack_public_path__ + "static/img/アセット 83@3x.ca583a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 83@3x.png
// module id = hgMc
// module chunks = 1